export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 90,
    slots: {
      default: 'opt',
    },
    visible: !that.disabled,
  },
  {
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('INDEX.table_label_custName') || '客户',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'endCustName',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('INDEX.order_form_label_endCustCode') || '终端客户',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'hscode',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('INDEX.shipment_customs_code_hscode') || '报关hscode',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'clearanceHscode',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('form_label_clearanceHscode') || '清关hscode',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'clearanceDuty',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('form_label_clearanceDuty') || '清关税率',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'clearanceDuty',
    },
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
